import { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { COACHES } from '../mock';

export default function MuziCoach({ coachId = 'c1', reaction = null, size = 'md' }) {
  const coach = COACHES.find((c) => c.id === coachId) || COACHES[0];
  const [currentPhrase, setCurrentPhrase] = useState(coach.phrases[0]);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (reaction) {
      setCurrentPhrase(reaction);
      setAnimating(true);
      const t = setTimeout(() => setAnimating(false), 700);
      return () => clearTimeout(t);
    }
  }, [reaction]);

  useEffect(() => {
    if (!reaction) {
      const interval = setInterval(() => {
        const idx = Math.floor(Math.random() * coach.phrases.length);
        setCurrentPhrase(coach.phrases[idx]);
        setAnimating(true);
        setTimeout(() => setAnimating(false), 600);
      }, 5500);
      return () => clearInterval(interval);
    }
  }, [coach, reaction]);

  const sizes = {
    sm: { circle: 'w-14 h-14 text-3xl', text: 'text-xs', bubble: 'text-xs max-w-[160px]' },
    md: { circle: 'w-20 h-20 text-5xl', text: 'text-sm', bubble: 'text-sm max-w-[220px]' },
    lg: { circle: 'w-28 h-28 text-6xl', text: 'text-base', bubble: 'text-base max-w-[280px]' },
  };
  const s = sizes[size];

  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        <div
          className={`${s.circle} rounded-full bg-gradient-to-br from-pink-500 via-purple-600 to-blue-500 flex items-center justify-center shadow-xl shadow-pink-500/40 ${animating ? 'bounce-soft' : 'float-soft'}`}
        >
          <span>{coach.emoji}</span>
        </div>
        <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-pink-500 flex items-center justify-center border-2 border-[#0A0A0F]">
          <Sparkles size={12} className="text-white" />
        </div>
      </div>
      <div className={`glass-light rounded-2xl px-4 py-2.5 ${s.bubble} ${animating ? 'scale-105' : 'scale-100'} transition-transform`}>
        <div className={`font-bold text-pink-400 ${s.text}`}>{coach.name}</div>
        <div className={`text-white ${s.text} leading-snug`}>{currentPhrase}</div>
      </div>
    </div>
  );
}
